export const CREATE_INVITES_FALLBACK_ERROR = 'Failed to send one or more invites';

type CreateInvitesResult = {
    status?: string;
    msg?: string;
    num_errors?: number;
    num_rows_errors?: number;
    error_emails?: string[];
};

/**
 * The invite endpoint returns HTTP 200 even when some or all sends failed
 * (`num_errors` / `error_emails`). A `{ status: 'error', msg }` body is the
 * other failure shape. Both must be shown as an error.
 */
export const getCreateInvitesFailureMessage = (res: CreateInvitesResult): string | null => {
    if (res.status === 'error') {
        return res.msg || CREATE_INVITES_FALLBACK_ERROR;
    }

    const errorEmails = res.error_emails ?? [];
    const errorCount = res.num_errors ?? res.num_rows_errors ?? 0;
    if (errorCount > 0 || errorEmails.length > 0) {
        if (errorEmails.length > 0) {
            return `Could not send invite to ${errorEmails.join(', ')}`;
        }

        return res.msg || CREATE_INVITES_FALLBACK_ERROR;
    }

    return null;
};

export const getCreateInvitesErrorEmails = (error: unknown): string[] => {
    if (!error || typeof error !== 'object' || !('error_emails' in error)) {
        return [];
    }

    const emails = (error as { error_emails?: unknown }).error_emails;
    if (!Array.isArray(emails)) {
        return [];
    }

    return emails.filter((email): email is string => typeof email === 'string' && email.length > 0);
};
